import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { CircleAlert } from "lucide-react";

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

const AccessDenied = ({ description }) => (
  <div className="tw:w-full">
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <CircleAlert />
        </EmptyMedia>
        <EmptyTitle>Access denied</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      <Link to="/">Back to home</Link>
    </Empty>
  </div>
);

AccessDenied.propTypes = {
  description: PropTypes.string.isRequired,
};

export default AccessDenied;
